import { ReactPlugin } from "@microsoft/applicationinsights-react-js";
import { ApplicationInsights } from "@microsoft/applicationinsights-web";

export const reactPlugin = process.env.REACT_APP_APP_INSIGHTS_CONNECTION_STRING
  ? new ReactPlugin()
  : (undefined as unknown as ReactPlugin);

export const setupAppInsights = () => {
  if (process.env.REACT_APP_APP_INSIGHTS_CONNECTION_STRING) {
    const appInsights = new ApplicationInsights({
      config: {
        connectionString: process.env.REACT_APP_APP_INSIGHTS_CONNECTION_STRING,
        extensions: [reactPlugin],
        enableAutoRouteTracking: false,
      },
    });
    appInsights.loadAppInsights();
    appInsights.trackPageView();
  }
};

export const EVENT_NAMES = {
  INCORRECT_REDIRECT_WHEN_SIGNUP_COMPANY:
    "incorrect_redirect_when_signup_company",
  FILL_SIGNUP_COMPANY_FORM: "fill_signup_company_form",
} as const;
export type EventName = typeof EVENT_NAMES[keyof typeof EVENT_NAMES];

class AppInsightEventTracker {
  private userData: {
    userId: string | null;
    userEmail: string | null;
    companyId: string | null;
  } = {
    userId: null,
    userEmail: null,
    companyId: null,
  };

  identify(userId: string, userEmail: string, companyId: string) {
    this.userData = {
      userId,
      userEmail,
      companyId,
    };
  }

  async track(name: EventName, properties: Record<string, any> = {}) {
    try {
      if (reactPlugin) {
        reactPlugin.trackEvent({
          name,
          properties: {
            platform: "web",
            version: "v1",
            userId: this.userData.userId,
            userEmail: this.userData.userEmail,
            companyId: this.userData.companyId,
            ...properties,
          },
        });
      }
    } catch (_error) {
      // Silent fail
    }
  }
}

const appInsightEventTracker = new AppInsightEventTracker();

export { appInsightEventTracker };
